import type {SortableEvent} from '@github-ui/sortablejs'

type Callback = (sortableEvent: SortableEvent) => unknown

export function moveWithButton(button: HTMLElement, item: HTMLElement, cb: Callback) {
  const direction = button.getAttribute('data-direction')
  const oldIndex = siblings(item).indexOf(item)

  if (direction === 'up' && item.previousElementSibling) {
    item.previousElementSibling.insertAdjacentElement('beforebegin', item)
  } else if (direction === 'down' && item.nextElementSibling) {
    item.nextElementSibling.insertAdjacentElement('afterend', item)
  }

  const newIndex = siblings(item).indexOf(item)

  // CSS hides first item's up button and last item's down button
  // Prefer the clicked button if still visible, otherwise switch to the other direction's button
  if (button.offsetParent !== null) {
    button.focus()
  } else {
    const otherButton = item.querySelector<HTMLElement>(`.js-sortable-button:not([data-direction="${direction}"])`)
    otherButton?.focus()
  }

  cb({oldIndex, newIndex, item})
}

function siblings(el: Element): Node[] {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const parent = el.parentElement!
  return Array.from(parent.children)
}
